import { isValidDate } from '../create/create-ts-date';
/**
 * Makes function that return part of ISO 8610 formatted string
 */
function createFormatIso(len) {
    return function (d) {
        if (!isValidDate(d))
            return null;
        var date = new Date(d.getTime());
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        return date.toISOString().substring(0, len);
    };
}
// YYYY-MM-DD
export var formatDateIso = createFormatIso(10);
// YYYY-MM-DDTHH:mm
export var formatDateTimeIso = createFormatIso(16);
// YYYY-MM-DDTHH:mm:ss.SSS
export var formatLocalIso = createFormatIso(23);



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/format/format-iso.js
// module id = null
// module chunks = 